import React, { Component } from "react";
import PropTypes from "prop-types";
import OwTitle from "../OwTitle/OwTitle";

/**
 * tag  - Specify the Title Tag (h1 - h6)
 * pleaseAdd - A boolean to determine if the title should say please add first item
 */
type Props = {
    tag?: string;
    pleaseAdd?: boolean;
};

class NoResults extends Component<Props> {
    render() {
        const tag = this.props.tag || "h5";

        let title = "no_results";

        if (this.props.pleaseAdd) {
            title = "please_add_first_entry";
        }

        return <OwTitle title={title} tag={tag} />;
    }
}

export default NoResults;
